<div [ngClass]="{ 'row align-items-center': layout === 'inline' }">
  @if (label) {
    <label [attr.for]="inputId" class="form-label" [ngClass]="{ 'col-form-label col-auto text-sm-right': layout === 'inline' }">
      {{ label }}
    </label>
  }
  <div [ngClass]="{ 'col-auto': layout === 'inline' && label }">
    <ng-select
      #select
      data-cy="chitinSelect"
      data-testid="chitinSelect"
      [ngClass]="{
        'form-control chitin-select': displayType === 'input',
        disabled: isDisabled,
        'btn btn-secondary buttonSelect': displayType === 'button',
        noArrow: alwaysOpen,
      }"
      [class]="(displayType === 'button' ? 'btn-' : 'form-control-') + size"
      [(ngModel)]="selectedItems"
      [items]="options"
      [bindLabel]="displayExpr"
      [bindValue]="valueExpr"
      [appendTo]="displayType === 'button' ? null : $any(appendTo)"
      [multiple]="multiple"
      (change)="emitValueChange($event)"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [disabled]="isDisabled || isLoading"
      [labelForId]="inputId"
      [searchable]="searchable === 'smart' ? optionsCount >= 3 : searchable"
      [clearable]="displayType === 'button' ? false : clearable"
      [closeOnSelect]="!multiple"
      [loading]="isLoading"
      [groupBy]="groupItems ? 'group' : $any(undefined)"
      [selectableGroup]="groupItems && multiple ? true : $any(undefined)"
      [selectableGroupAsModel]="groupItems && multiple ? false : $any(undefined)"
      [maxSelectedItems]="maxNumOfOptions ?? $any(undefined)"
      [dropdownPosition]="dropdownPosition"
      (open)="onOpen(select)"
      (close)="onClose()"
      [isOpen]="alwaysOpen ? true : $any(undefined)"
      [keyDownFn]="onKeyDown"
      [compareWith]="compareFn ? compareFn : $any(undefined)"
    >
      @if (multiple && (displayNumberOfSelected || selectionDisplay); as items) {
        <ng-template ng-multi-label-tmp let-items="items">
          @if (!displayNumberOfSelected && selectionDisplay) {
            <div>{{ selectionDisplay }}</div>
          }
          @if (displayNumberOfSelected) {
            @if (items.length) {
              <div class="ng-value">
                <span class="ng-value-label">{{ items.length }} selected</span>
              </div>
            }
          }
        </ng-template>
      }
      @if (valueType !== 'item') {
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
          @if (multiple && showSelectAll && index === 0) {
            <ng-template [ngTemplateOutlet]="massSelectButtons" />
          }
          @if (!item.group || groupsExpanded[item.group]) {
            @if (!!item.subGroupTitle) {
              <div class="subGroupTitle">{{ item.subGroupTitle }}</div>
            }
            @if (checkboxView && item.value !== SELECT_ALL_VALUE) {
              <input
                id="item-{{ index }}"
                type="checkbox"
                [ngModel]="item.value === SELECT_ALL_VALUE ? false : item$.selected"
                [ngClass]="{ 'ms-3': item.group }"
                style="pointer-events: none"
              />
            }
            <span class="ms-2" data-testid="spanSelectOption" [style]="item.description ? 'font-size: var(--fs-lg)' : ''">{{
              item[displayExpr]
            }}</span>
            @if (item.description) {
              <div class="ms-4 pe-4" style="max-width: 100%; white-space: normal !important; opacity: 0.7; font-size: var(--fs-sm)">
                {{ item.description }}
              </div>
            }
            @if (item.badge) {
              <span class="badge badge-pill rounded ms-2" [ngClass]="item.badgeClass">{{ item.badge }}</span>
            }
          } @else {
            <div class="itemHidden"></div>
          }
        </ng-template>
      }
      @if (checkboxView) {
        <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
          @if (multiple && showSelectAll && index === 0) {
            <ng-template [ngTemplateOutlet]="massSelectButtons" />
          }
          <chitin-icon
            [icon]="'fa-solid ' + (groupsExpanded[item.group] ? 'fa-chevron-down' : 'fa-chevron-right')"
            class="px-2"
            style="margin-left: var(--space-x-n0p5rem)"
            data-testid="selectOptionGroupExpand"
            (click)="onItemExpanded(item, $event)"
          />
          <input
            id="item-{{ index }}"
            type="checkbox"
            [ngModel]="item$.selected"
            style="pointer-events: none"
            data-testid="selectOptionGroup"
            [attr.data-group]="item.group"
          />
          {{ item.group }}
        </ng-template>
      }
      @if (!checkboxView) {
        <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
          @if (multiple && showSelectAll && index === 0) {
            <ng-template [ngTemplateOutlet]="massSelectButtons" />
          }
          <div data-testid="selectOptionGroupExpand" (click)="onItemExpanded(item, $event)">
            <chitin-icon
              [icon]="'fa-solid ' + (groupsExpanded[item.group] ? 'fa-chevron-down' : 'fa-chevron-right')"
              class="px-2"
              style="margin-left: var(--space-x-n0p5rem)"
            />
            <span data-testid="selectOptionGroup" [attr.data-group]="item.group">{{ item.group }}</span>
          </div>
        </ng-template>
      }
    </ng-select>
  </div>
</div>

<ng-template #massSelectButtons>
  <div class="massSelectButtons">
    <a data-testid="selectAllOptions" (click)="onSelectAllClicked(false, $event)">Select all</a>
    <a data-testid="deselectAllOptions" (click)="onSelectAllClicked(true, $event)">Deselect all</a>
  </div>
</ng-template>
